import React, { Component } from "react";
import { Box, Flex, Text } from "rebass";
import { Block, Tabs } from "reakit";
import { height, maxHeight } from "styled-system";
import { withRouter } from "react-router";
import styled from "styled-components";
import { Switch } from "@smooth-ui/core-sc";

/**
 * Custom components
 */
import {
  Content,
  DesktopBox,
  MobileBox,
  MobileHeader,
  PositionBox,
  TabHeader,
} from "../../components/Base";
import { PageTitle } from "../../components/Base/Text";
import UserList from "../../components/UserList";
import Loading from "../../components/Base/Loading";
import StudentFilterDropdown from "../../components/Search/StudentFilterDropdown";
import ApplyFilter from "../../components/Search/ApplyFilters";
import BasicSearch from "../../components/Forms/BasicSearch";

import HealthAdminHistoryPopup from "../../components/HealthAdmin/HealthAdminHistoryPopup";
import HealthAdminHistoryMobile from "../../components/HealthAdmin/HealthAdminHistoryMobile";

import { filterSearchResults, returnFilterString } from "../../utils";

const ListWrapper = styled(Box)`
  ${maxHeight}
  ${height}
margin-top: 18px
`;

ListWrapper.defaultProps = {
  height: ["calc(100vh - 162px)", "calc(100vh - 330px)"],
};

class HealthAdmin extends Component {
  state = {
    name: "",
    search: "",
    filters: {
      health: [],
      grade: [],
      location: [],
      dorm: [],
      gender: [],
      type: [],
    },
    showOverlay: false,
    selected: null,
    currentTab: "STUDENTS",
    staffOnly: false,
    facultyOnly: false,
  };

  componentDidMount() {}

  componentWillUnmount() {}

  filterListWithSearch = (list, search = "") => {
    return list.filter((student) => {
      if (student.first_name) {
        return (
          student.first_name.toLowerCase() +
          " " +
          student.last_name.toLowerCase()
        ).includes(search.toLowerCase());
      } else {
        return false;
      }
    });
  };

  handleInput = (e) => {
    this.setState({ name: e.target.value });
  };

  handleSelect = (details) => {
    this.setState({ selected: details });
    this.toggleOverlay();
  };

  toggleOverlay = () => {
    const { showOverlay } = this.state;

    if (showOverlay) {
      this.setState({ showOverlay: false });
    } else {
      this.setState({ showOverlay: true });
    }
  };

  updateFilter = (newFilters) => {
    this.setState({ filters: newFilters });
  };

  clearFilter = () => {
    this.setState({
      filters: {
        health: [],
        grade: [],
        location: [],
        dorm: [],
        gender: [],
        type: [],
      },
    });
  };

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  };

  onSwitchStaff = () => {
    const { staffOnly } = this.state;
    if (staffOnly) {
      this.setState({ staffOnly: false });
    } else {
      this.setState({ staffOnly: true, facultyOnly: false });
    }
  };

  onSwitchFaculty = () => {
    const { facultyOnly } = this.state;
    if (facultyOnly) {
      this.setState({ facultyOnly: false });
    } else {
      this.setState({ facultyOnly: true, staffOnly: false });
    }
  };

  render() {
    const { loading, students, faculty, profile, schoolInfo } = this.props;
    const {
      search,
      showOverlay,
      selected,
      currentTab,
      staffOnly,
      facultyOnly,
    } = this.state;

    let studentList = filterSearchResults(this.state.filters, students);

    let facultyList = faculty;

    if (staffOnly) {
      facultyList = facultyList.filter((f) => f.is_staff === true);
    } else if (facultyOnly) {
      facultyList = facultyList.filter(
        (f) => f.is_staff === false || f.is_staff === undefined
      );
    }

    facultyList = filterSearchResults(this.state.filters, facultyList);

    if (search !== null && search !== undefined) {
      if (facultyList.length > 0) {
        facultyList = this.filterListWithSearch(facultyList, search);
      }
      if (studentList.length > 0) {
        studentList = this.filterListWithSearch(studentList, search);
      }
    }

    let filterTitle = returnFilterString(this.state.filters, schoolInfo);
    if (filterTitle === "All Students") {
      filterTitle = "All";
    }

    return (
      <Box>
        <DesktopBox pl={3} pb={3} pt={3}>
          <Flex>
            <PageTitle style={{ marginTop: "0.5em" }} color={"#263039"} pl={3}>
              Health (Admin)
            </PageTitle>

            <Box ml={"auto"} />
            {profile !== null && (
              <Box width={[2 / 5]} pt={3} pr={"8px"}>
                <BasicSearch
                  handleInput={this.handleSearchChange}
                  search={search}
                  placeholders={
                    this.state.isStudentTab
                      ? "Search Student"
                      : "Search Faculty"
                  }
                />
              </Box>
            )}
          </Flex>
        </DesktopBox>
        <Tabs.Container>
          {(tabs) => (
            <Block>
              <MobileHeader>
                <PageTitle pt={2} color={"#263039"}>
                  Health (Admin)
                </PageTitle>
                <Flex flexDirection={"row"} justifyContent={"space-between"}>
                  <Flex>
                    <ApplyFilter
                      isNew={true}
                      filters={JSON.parse(JSON.stringify(this.state.filters))}
                      clearFilter={this.clearFilter}
                      school={schoolInfo}
                      updateFilters={this.updateFilter}
                      title={filterTitle}
                      isHealth
                    />
                  </Flex>

                  {currentTab === "EMPLOYEES" && (
                    <Flex>
                      <Text
                        fontSize={0}
                        fontWeight={700}
                        py={2}
                        mt={"3px"}
                        color={"meta"}
                      >
                        STAFF ONLY
                      </Text>
                      <Switch
                        name={"staffOnly"}
                        checked={staffOnly}
                        onChange={this.onSwitchStaff}
                      />
                    </Flex>
                  )}

                  {currentTab === "EMPLOYEES" && (
                    <Flex>
                      <Text
                        fontSize={0}
                        fontWeight={700}
                        py={2}
                        mt={"3px"}
                        color={"meta"}
                      >
                        FACULTY ONLY
                      </Text>
                      <Switch
                        name={"facultyOnly"}
                        checked={facultyOnly}
                        onChange={this.onSwitchFaculty}
                      />
                    </Flex>
                  )}
                </Flex>
                <Tabs>
                  <Tabs.Tab
                    tab="first"
                    {...tabs}
                    onClick={() => this.setState({ currentTab: "STUDENTS" })}
                  >
                    <TabHeader title={"Students"} />
                  </Tabs.Tab>
                  <Tabs.Tab
                    tab="second"
                    {...tabs}
                    onClick={() => this.setState({ currentTab: "EMPLOYEES" })}
                  >
                    <TabHeader title={"Employees"} />
                  </Tabs.Tab>
                </Tabs>
              </MobileHeader>

              <Content>
                <MobileBox>
                  <PositionBox
                    position={"fixed"}
                    top={"169px"}
                    width={1}
                    zIndex={999}
                  >
                    {!loading && (
                      <BasicSearch
                        handleInput={this.handleSearchChange}
                        search={search}
                        placeholders={
                          this.state.isStudentTab
                            ? "Search Student"
                            : "Search Faculty"
                        }
                      />
                    )}

                    {showOverlay && selected && window.innerWidth <= 800 && (
                      <HealthAdminHistoryMobile
                        {...this.props}
                        visible={showOverlay}
                        toggle={this.toggleOverlay}
                        selected={selected}
                        selectedIsStudent={selected.grade != null}
                        firebase={this.props.firebase}
                      />
                    )}
                  </PositionBox>
                </MobileBox>
                <DesktopBox>
                  <Flex flexDirection={"row"}>
                    <Text
                      style={{ marginLeft: "0.5em" }}
                      fontSize={0}
                      fontWeight={700}
                      py={2}
                      mt={"3px"}
                      color={"meta"}
                    >
                      FILTER
                    </Text>

                    <Flex ml={3} pt={2}>
                      <StudentFilterDropdown
                        updateFilters={this.updateFilter}
                        clearFilter={this.clearFilter}
                        filters={this.state.filters}
                        titleColor={"black"}
                        title={filterTitle}
                      />
                    </Flex>

                    {currentTab === "EMPLOYEES" && (
                      <React.Fragment>
                        <Text
                          style={{ marginLeft: "2em" }}
                          fontSize={0}
                          fontWeight={700}
                          py={2}
                          mt={"3px"}
                          color={"meta"}
                        >
                          STAFF ONLY
                        </Text>
                        <Flex ml={3} pt={1}>
                          <Switch
                            name={"staffOnly"}
                            checked={staffOnly}
                            onChange={this.onSwitchStaff}
                          />
                        </Flex>
                      </React.Fragment>
                    )}

                    {currentTab === "EMPLOYEES" && (
                      <React.Fragment>
                        <Text
                          style={{ marginLeft: "2em" }}
                          fontSize={0}
                          fontWeight={700}
                          py={2}
                          mt={"3px"}
                          color={"meta"}
                        >
                          FACULTY ONLY
                        </Text>
                        <Flex ml={3} pt={1}>
                          <Switch
                            name={"facultyOnly"}
                            checked={facultyOnly}
                            onChange={this.onSwitchFaculty}
                          />
                        </Flex>
                      </React.Fragment>
                    )}
                  </Flex>
                  <Tabs>
                    <Tabs.Tab
                      tab="first"
                      {...tabs}
                      onClick={() => this.setState({ currentTab: "STUDENTS" })}
                    >
                      <TabHeader title={"Students"} />
                    </Tabs.Tab>
                    <Tabs.Tab
                      tab="second"
                      {...tabs}
                      onClick={() => this.setState({ currentTab: "EMPLOYEES" })}
                    >
                      <TabHeader title={"Employees"} />
                    </Tabs.Tab>
                  </Tabs>
                  {showOverlay && selected && window.innerWidth > 800 && (
                    <HealthAdminHistoryPopup
                      visible={showOverlay}
                      toggle={this.toggleOverlay}
                      selected={selected}
                      selectedIsStudent={selected.grade != null}
                      firebase={this.props.firebase}
                    />
                  )}
                </DesktopBox>
                <Tabs.Panel tab="first" {...tabs}>
                  {loading ? (
                    <Loading />
                  ) : (
                    <ListWrapper>
                      <UserList
                        students={studentList}
                        handleUserClick={this.handleSelect}
                        useWindow
                        withHealth
                        infiniteScroll
                      />
                    </ListWrapper>
                  )}
                </Tabs.Panel>
                <Tabs.Panel tab="second" {...tabs}>
                  {loading ? (
                    <Loading />
                  ) : (
                    <ListWrapper>
                      <UserList
                        students={facultyList}
                        handleUserClick={this.handleSelect}
                        useWindow
                        withHealth
                        infiniteScroll
                      />
                    </ListWrapper>
                  )}
                </Tabs.Panel>
              </Content>
            </Block>
          )}
        </Tabs.Container>
      </Box>
    );
  }
}

export default withRouter(HealthAdmin);
